export const FETCH_LIST_ACCOUNT_REQUEST = "FETCH_LIST_ACCOUNT_REQUEST";
export const FETCH_LIST_ACCOUNT_SUCCESS = "FETCH_LIST_ACCOUNT_SUCCESS";
export const FETCH_LIST_ACCOUNT_FAILURE = "FETCH_LIST_ACCOUNT_FAILURE";

export const FETCH_ACCOUNT_DETAIL_REQUEST = "FETCH_ACCOUNT_DETAIL_REQUEST";
export const FETCH_ACCOUNT_DETAIL_SUCCESS = "FETCH_ACCOUNT_DETAIL_SUCCESS";
export const FETCH_ACCOUNT_DETAIL_FAILURE = "FETCH_ACCOUNT_DETAIL_FAILURE";

export const FETCH_LIMIT_REMAIN_REQUEST = "FETCH_LIMIT_REMAIN_REQUEST";
export const FETCH_LIMIT_REMAIN_SUCCESS = "FETCH_LIMIT_REMAIN_SUCCESS";
export const FETCH_LIMIT_REMAIN_FAILURE = "FETCH_LIMIT_REMAIN_FAILURE";

export const FETCH_LIST_ACCOUNT_LOGIN_REQUEST = "FETCH_LIST_ACCOUNT_LOGIN_REQUEST";
export const FETCH_LIST_ACCOUNT_LOGIN_SUCCESS = "FETCH_LIST_ACCOUNT_LOGIN_SUCCESS";
export const FETCH_LIST_ACCOUNT_LOGIN_FAILURE = "FETCH_LIST_ACCOUNT_LOGIN_FAILURE";

export const FETCH_CUSTOMER_POSITION_REQUEST = "FETCH_CUSTOMER_POSITION_REQUEST";
export const FETCH_CUSTOMER_POSITION_SUCCESS = "FETCH_CUSTOMER_POSITION_SUCCESS";
export const FETCH_CUSTOMER_POSITION_FAILURE = "FETCH_CUSTOMER_POSITION_FAILURE";

export const SET_CONTACT_ID_STORE = "SET_CONTACT_ID_STORE";
